// API service pour le formulaire de contact public
import { apiCall } from './api';

export const sendContactMessage = async (contactData) => {
  return apiCall('/contact/', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(contactData),
  });
};
